export default {
  full_menu: 'Menu completo',
  free: 'GRATIS',
};
